import { render, staticRenderFns } from "./CustomFieldsFormDialogComponent.vue?vue&type=template&id=5ad35653&scoped=true&lang=pug"
import script from "./CustomFieldsFormDialogComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsFormDialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldsFormDialogComponent.vue?vue&type=style&index=0&id=5ad35653&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad35653",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad35653')) {
      api.createRecord('5ad35653', component.options)
    } else {
      api.reload('5ad35653', component.options)
    }
    module.hot.accept("./CustomFieldsFormDialogComponent.vue?vue&type=template&id=5ad35653&scoped=true&lang=pug", function () {
      api.rerender('5ad35653', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/CustomFieldsFormDialog/CustomFieldsFormDialogComponent.vue"
export default component.exports